import { Box, Stack } from '@mui/material';
import React from 'react';

import { WsTypography, WsTypoColors, WsTypoVariants } from '../WsTypography';

export interface WsTitleHeaderProps {
  title: string;
  subtitle?: string;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  color: WsTitleColors;
  reversed?: boolean;
  opacity?: boolean;
}
export enum WsTitleColors {
  PRIMARY500 = 'primary',
  PRIMARY200 = 'primary200',
  BLACK = 'black',
  WHITE = 'white',
  YELLOW = 'yellow',
}
const mapColor = new Map();
mapColor.set('primary', WsTypoColors.PRIMARY);
mapColor.set('primary200', WsTypoColors.PRIMARY200);
mapColor.set('black', WsTypoColors.BLACK);
mapColor.set('white', WsTypoColors.WHITE);
mapColor.set('yellow', WsTypoColors.YELLOW);

const WsTitleHeader = ({
  title = '',
  subtitle = '',
  startIcon,
  endIcon,
  color,
  reversed,
  opacity,
}: WsTitleHeaderProps) => (
  <Box>
    <Stack direction="row" spacing={2} alignItems="center">
      <Box py={1} sx={{ cursor: 'pointer' }}>
        {startIcon}
      </Box>
      <Stack direction={reversed ? 'column-reverse' : 'column'}>
        <WsTypography color={mapColor.get(color)} variant={WsTypoVariants.TITLE} cursor="pointer">
          {title}
        </WsTypography>
        <WsTypography
          color={mapColor.get(color)}
          variant={WsTypoVariants.BODY2}
          opacity={opacity}
          cursor="pointer"
        >
          {subtitle}
        </WsTypography>
      </Stack>
      <Box py={1}>{endIcon}</Box>
    </Stack>
  </Box>
);
export default WsTitleHeader;
